export const taskDateFormat = (isoDate) => {
  const date = new Date(isoDate);
  const now = new Date();
  const diff = now.getTime() - date.getTime(); // Calculate time difference in milliseconds

  // Calculate elapsed time in seconds, minutes, hours, days, months, and years
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30); // Approximate, not precise
  const years = Math.floor(months / 12);

  if (seconds < 60) {
    return `${seconds} sec ago`;
  } else if (minutes < 60) {
    return `${minutes} min ago`;
  } else if (hours < 24) {
    return `${hours} hours ago`;
  } else if (days < 30) {
    // return `${days} days ago`;
    if (days === 0) {
      return "Today";
    } else if (days === 1) {
      return "Yesterday";
    } else {
      return `${days} days ago`;
    }
  } else if (months < 12) {
    return date.toLocaleString("en-US", { month: "long", year: "numeric" });
  } else {
    return date.toLocaleString("en-US", { year: "numeric" });
  }
};

export const filterIssue = (data) => {
  return data.filter((item) =>
    ["Story", "Bug", "Task"].includes(item.fields.issuetype?.name)
  );
};

export const generatedId = () => {
  return `id-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
};

export const getSubTasks = (fullData, sectionId, story) => {
  const section = fullData.find(
    (section) => section.id === sectionId.toString()
  );
  return section?.issues.filter(
    (issue) => issue.fields?.parent?.id === story.id
  );
};

export const calculateEndDate = (startDate, duration) => {
  if (!startDate) return "";

  const start = new Date(startDate);
  let daysToAdd = 7;

  if (duration === "2 weeks") daysToAdd = 14;
  else if (duration === "3 weeks") daysToAdd = 21;

  start.setDate(start.getDate() + daysToAdd);
  return start.toISOString().split("T")[0];
};